import { useState } from 'react';
import React from 'react';
import '../styles/BeneficiaryForm.css';
import SendEmail from './SendEmail';
import { allowedKeysByType, translateKey, getStatusInHebrew } from '../utils/translations';

const GenericDetails = ({ data, type = 'donor', onDelete, onUpdate }) => {
    const [isEmailPopupOpen, setIsEmailPopupOpen] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState(null);

    const sendEmail = (email) => {
        setSelectedEmail(email);
        setIsEmailPopupOpen(true);
    };

    const formatDate = (isoString) => {
        if (!isoString) return '';
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const allowedKeys = allowedKeysByType[type] || [];


    return (
        <>
            <div className="details-header">
                <h1 className="beneficiary-title">
                    כרטסת {data.first_name} {data.last_name}
                </h1>
            </div>

            <div className="beneficiary-info-inline">
                {allowedKeys.map((key) => {

                    if (data[key] === null || data[key] === undefined || data[key] === '') return null;

                    return (
                        <span key={key} className="field-wrapper">
                            <strong style={{ color: '#7879F1' }}>
                                {(key === 'donor_id' || key === 'id') && data[key] && /[A-Z]/i.test(data[key])
                                    ? 'דרכון'
                                    : translateKey(key)}:
                            </strong>&nbsp;
                            
                            <span style={{ color: '#212529' }}>
                                {key === 'status' ? getStatusInHebrew(data[key])
                                    : (key === 'createdAt' || key === 'join_date') ? formatDate(data[key]) : data[key]}
                            </span>

                            {key === "email" && (
                                <button
                                    id="email-btn"
                                    className="icon-btn"
                                    title="שלח אימייל"
                                    onClick={() => sendEmail(data[key])}
                                >
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                        strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M4 4h16c1.1 0 2 .9 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2z" />
                                        <polyline points="22,6 12,13 2,6" />
                                    </svg>
                                </button>
                            )}
                        </span>
                    );
                })}

                {/* פופ-אפ אימייל */}
                {isEmailPopupOpen && (
                    <SendEmail
                        onClose={() => setIsEmailPopupOpen(false)}
                        recipientEmail={selectedEmail}
                    />
                )}

       
            <div className="actions-section" style={{ display: 'contents' }}>
                {onDelete && (
                    <button className="action-btn delete-btn" onClick={onDelete} title="מחיקת כרטסת">
                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M3 5.5H17" />
                        <path d="M7 5.5V4C7 3.44772 7.44772 3 8 3H12C12.5523 3 13 3.44772 13 4V5.5" />
                        <path d="M9 8.5V15.5" />
                        <path d="M11 8.5V15.5" />
                        <path d="M5 5.5H15L16 17C16 17.5523 15.5523 18 15 18H5C4.44772 18 4 17.5523 4 17L5 5.5Z" />
                    </svg>
                        מחיקת כרטסת
                    </button>
                )}

                    {onUpdate && (
                        <button className="action-btn update-btn" onClick={onUpdate} title="עדכון פרטים">
                            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                            </svg>
                            עדכון פרטים
                        </button>
                    )}
                </div>
            </div>
        </>
    );
};

export default GenericDetails;


